import { useHookstate } from '@hookstate/core';
import { useMemo } from 'react';
import { current } from '../stores/backend';

export const useCurrentPartsSize = () => {
    const $current = useHookstate(current);

    void $current.game_parts.value; // subscribe to game_parts

    const parts = useMemo(
        () => Object.keys($current.game_parts.value).length,
        [$current.game_parts]
    );

    return parts;
};
